export default __webpack_public_path__ + "static/Desktop-11a5ee657ce2c233c889400032a8e9a1.jpg";